/**
 * @module app.cm
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { IPopup } from 'app/shared/elements/popup-base';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { localSort } from 'app/shared/lib/sorting';
import { deepClone } from 'app/shared/lib/utilities';
import * as CM from 'app/cm/models/essette-api';


@autoinject()
export class IntensitiesDisplayModal extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.array({ defaultBindingMode: bindingMode.oneTime })
    protected intensities: CM.Intensity[] = [];

    protected displayedIntensities: CM.Intensity[] | null = null;

    protected selectedIntensityId: string | null = null;
    private sorting: Sorting = new Sorting();

    ////****************** Element References ***************************************////
    protected $modal!: IPopup;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////
    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        if(!this.displayedIntensities) return;

        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }

        if(this.sorting.entries.length > 0) localSort(this.displayedIntensities, sorting);
        else this.displayedIntensities = deepClone(this.intensities);
    }

    ////****************** Functions ************************************************////
    public open(selectedIntensityId: string | null = null): void {
        if(!this.displayedIntensities) this.displayedIntensities = deepClone(this.intensities);
        this.selectedIntensityId = selectedIntensityId;
        this.$modal.open();
    }
}
